import Config from './Config';
import { version as uuidVersion, validate as validUniqueID, v4 as generateDeviceID, v1 as generateSessionID } from 'uuid';
var Device = /** @class */ (function () {
    function Device(switchCallback, persistent) {
        if (persistent === void 0) { persistent = true; }
        this.persistent = persistent;
        this.deviceIdStorageKey = Config.LS_DOMAIN_ID;
        this.deviceId = this.initDeviceId(switchCallback);
        this.sessionId = this.initSession();
        this.setPersistent(persistent);
    }
    /**
     * Follow the analytics consent: persist the in-memory ids when granted,
     * remove every stored copy when not. Idempotent.
     */
    Device.prototype.setPersistent = function (persistent) {
        this.persistent = persistent;
        try {
            if (persistent) {
                localStorage.setItem(this.deviceIdStorageKey, this.deviceId);
                sessionStorage.setItem(Config.LS_SESSION_ID, this.sessionId);
            }
            else {
                localStorage.removeItem(Config.LS_DOMAIN_ID);
                localStorage.removeItem(Config.LS_BROWSER_ID);
                sessionStorage.removeItem(Config.LS_SESSION_ID);
            }
        }
        catch (_a) {
            // Storage blocked (private mode / quota): the ids stay in memory.
        }
    };
    Device.prototype.initDeviceId = function (switchCallback) {
        var urlParams = new URLSearchParams(window.location.search);
        var browserIdFromQueryParam = urlParams.get(Config.QUERY_PARAM_BROWSER_ID);
        var browserIdFromLocalStorage = localStorage.getItem(Config.LS_BROWSER_ID);
        var domainIdFromLocalStorage = localStorage.getItem(Config.LS_DOMAIN_ID);
        if (browserIdFromQueryParam) {
            urlParams.delete(Config.QUERY_PARAM_BROWSER_ID);
            window.history.replaceState({}, document.title, window.location.pathname + '?' + urlParams.toString());
        }
        if (browserIdFromQueryParam && this.validUniqueID(browserIdFromQueryParam)) {
            if (browserIdFromLocalStorage) {
                switchCallback(browserIdFromLocalStorage, browserIdFromQueryParam);
            }
            if (domainIdFromLocalStorage) {
                switchCallback(domainIdFromLocalStorage, browserIdFromQueryParam);
                localStorage.removeItem(Config.LS_DOMAIN_ID);
            }
            this.deviceIdStorageKey = Config.LS_BROWSER_ID;
            return browserIdFromQueryParam;
        }
        else if (browserIdFromLocalStorage) {
            if (domainIdFromLocalStorage) {
                switchCallback(domainIdFromLocalStorage, browserIdFromLocalStorage);
                localStorage.removeItem(Config.LS_DOMAIN_ID);
            }
            this.deviceIdStorageKey = Config.LS_BROWSER_ID;
            return browserIdFromLocalStorage;
        }
        else if (domainIdFromLocalStorage) {
            this.deviceIdStorageKey = Config.LS_DOMAIN_ID;
            return domainIdFromLocalStorage;
        }
        else {
            var domainId = generateDeviceID();
            this.deviceIdStorageKey = Config.LS_DOMAIN_ID;
            return domainId;
        }
    };
    Device.prototype.validUniqueID = function (id) {
        return validUniqueID(id) && uuidVersion(id) === 4;
    };
    Device.prototype.initSession = function () {
        return sessionStorage.getItem(Config.LS_SESSION_ID) || generateSessionID();
    };
    Device.prototype.getDeviceID = function () {
        return this.deviceId;
    };
    /**
     * Align to the `did` core-input resolved server-side (see SendRoutine's
     * onDidSync, populated from every /events response's `did` field). The
     * did cookie there is a second source of truth: when it disagrees with
     * what this browser sent (e.g. localStorage was reset, or another tab
     * already synced a different value), the server wins and we adopt it.
     */
    Device.prototype.syncDeviceID = function (newId) {
        if (!newId || newId === this.deviceId)
            return;
        this.deviceId = newId;
        if (this.persistent)
            localStorage.setItem(this.deviceIdStorageKey, newId);
    };
    Device.prototype.getSession = function () {
        return this.sessionId;
    };
    return Device;
}());
export default Device;
